import * as GridCell from '@progress/kendo-react-grid'
import React from 'react';
import * as Actions from './actions'
import './styles.css'

export class DragCell extends GridCell.GridCell {
  private eventName: string = ''
  constructor(props: GridCell.GridCellProps, eventName: string) {
    super(props);
    this.eventName = eventName
  }

  public render() {
    return (
      <td className="drag-cell" onDragEnter={() => this.dragOver() }>
        <span draggable={true}
              className="k-icon k-i-reorder"
              style={{ cursor: 'move', fontSize: '36px' }}
              onDragStart={(e) => this.startDragging()}
              onDragEnd={(e) => this.endDragging()}>
        </span>
      </td>
  )}

  private dragOver = () => {
    this.props.dataItem.dispatch(Actions.dragOver(this.eventName, this.props.dataItem))
  }

  private startDragging = () => {
    this.props.dataItem.dispatch(Actions.dragStart(this.eventName, this.props.dataItem))
  }

  private endDragging = () => {
    this.props.dataItem.dispatch(Actions.dragEnd(this.eventName, this.props.dataItem))
  }

}



// WEBPACK FOOTER //
// ./src/components/drag-cell/component.tsx